import React from "react";

const Contact = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white">
      <div className="relative flex-grow">
        <img
          src="./C1.png"
          className="absolute h-[500px] w-full object-cover opacity-30 sm:h-[800px]"
          alt="Background"
        />
        <div className="relative flex flex-col pt-16 px-4 sm:pt-20 sm:px-8 lg:flex-row lg:pt-20 lg:px-20">
          {/* Left Section with Original Glow Effect */}
          <div className="bg-gray-800 bg-opacity-80 w-full sm:w-[530px] h-auto sm:h-[530px] mb-6 lg:mb-0 lg:mr-4 rounded-lg shadow-lg border border-white/20 ring-8 ring-cyan-500 shadow-[0_0_40px_10px_rgba(0,255,255,0.6)] p-4 sm:p-6 lg:p-8">
            <div className="text-cyan-400 mb-4">
              <div className="font-extrabold text-xl sm:text-2xl font-serif">
                Contact Us
              </div>
              <div className="text-base sm:text-xl font-sans">
                Learn more about My AlumniConnect Website and how we're
                <br />
                connecting alumni, facilitating collaboration, and 
                <br />
                building a strong community for our 
                <br />
                members.
              </div>
            </div>
            <div className="text-xl sm:text-xl font-serif text-cyan-400 mb-4">
              Ready to get started? Let's Talk.
            </div>
            <div className="font-extrabold text-cyan-400 mb-4">
              Office Location
            </div>
            <div className="text-sm sm:text-base font-serif text-gray-300">
              My AlumniConnect Website | Kulgaon Road <br />
              Rooma | Kanpur - 208001, India
            </div>
          </div>

          {/* Right Section with Enhanced Glow Effect */}
          <div className="bg-gray-800 bg-opacity-80 w-full sm:w-[580px] h-auto sm:h-[530px] rounded-lg shadow-lg border border-white/20 ring-8 ring-cyan-500 shadow-[0_0_40px_10px_rgba(0,255,255,0.6)] p-4 sm:p-6 lg:ml-4">
            <div>
              <div className="font-extrabold text-xl sm:text-2xl font-serif text-cyan-400 mb-4">
                Contact Us
              </div>

              <div className="flex flex-col sm:flex-row sm:gap-4 pt-4">
                <label className="font-sans font-bold text-cyan-400 mb-2 sm:mb-0 sm:w-1/3">Name</label>
                <div className="flex flex-col sm:flex-row sm:gap-4 w-full">
                  <input
                    placeholder="First Name"
                    className="pl-2 w-full sm:w-[130px] border border-gray-500 rounded-md bg-gray-700 text-white shadow-[0_0_20px_rgba(255,87,34,0.9)] mb-2 sm:mb-0"
                  />
                  <input
                    placeholder="Last Name"
                    className="pl-2 w-full sm:w-[130px] border border-gray-500 rounded-md bg-gray-700 text-white shadow-[0_0_20px_rgba(255,87,34,0.9)]"
                  />
                </div>
              </div>

              <div className="flex flex-col sm:flex-row sm:gap-4 pt-4">
                <label className="font-sans font-bold text-cyan-400 mb-2 sm:mb-0 sm:w-1/3">Profession</label>
                <input
                  placeholder="Status"
                  className="pl-2 w-full border border-gray-500 rounded-md bg-gray-700 text-white shadow-[0_0_20px_rgba(255,87,34,0.9)]"
                />
              </div>

              <div className="flex flex-col sm:flex-row sm:gap-4 pt-4">
                <label className="font-sans font-bold text-cyan-400 mb-2 sm:mb-0 sm:w-1/3">College</label>
                <div className="flex flex-col sm:flex-row sm:gap-4 w-full">
                  <input
                    placeholder="Name"
                    className="pl-2 w-full sm:w-[180px] border border-gray-500 rounded-md bg-gray-700 text-white shadow-[0_0_20px_rgba(255,87,34,0.9)] mb-2 sm:mb-0"
                  />
                  <input
                    placeholder="Zip"
                    className="pl-2 w-full sm:w-[80px] border border-gray-500 rounded-md bg-gray-700 text-white shadow-[0_0_20px_rgba(255,87,34,0.9)]"
                  />
                </div>
              </div>

              <div className="flex flex-col sm:flex-row sm:gap-4 pt-4">
                <label className="font-sans font-bold text-cyan-400 mb-2 sm:mb-0 sm:w-1/3">Phone</label>
                <input
                  placeholder="123-456-7890"
                  className="pl-2 w-full border border-gray-500 rounded-md bg-gray-700 text-white shadow-[0_0_20px_rgba(255,87,34,0.9)]"
                />
              </div>

              <div className="flex flex-col sm:flex-row sm:gap-4 pt-4">
                <label className="font-sans font-bold text-cyan-400 mb-2 sm:mb-0 sm:w-1/3">Email</label>
                <input
                  placeholder="example@gmail.com"
                  className="pl-2 w-full border border-gray-500 rounded-md bg-gray-700 text-white shadow-[0_0_20px_rgba(255,87,34,0.9)]"
                />
              </div>

              <div className="flex items-center pt-4">
                <input
                  id="default-checkbox"
                  type="checkbox"
                  className="w-4 h-4 text-blue-600 bg-gray-700 border-gray-500 rounded focus:ring-blue-500 focus:ring-2"
                />
                <label
                  htmlFor="default-checkbox"
                  className="ml-2 text-sm font-medium text-gray-300"
                >
                  Terms and Conditions
                </label>
              </div>

              <div className="flex justify-center pt-6 gap-4 flex-col sm:flex-row">
                <div className="w-full sm:w-auto bg-slate-700 text-sm font-serif rounded-lg transition-all duration-500 hover:shadow-lg">
                  <button className="w-full sm:w-[90px] h-[36px] m-2 text-gray-300">Go Back</button>
                </div>
                <div className="w-full sm:w-auto bg-green-600 text-sm font-serif rounded-lg transition-all duration-500 hover:bg-green-700 hover:shadow-lg hover:shadow-green-500/50">
                  <button className="w-full sm:w-[90px] h-[36px] m-2 text-white">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-28"></div>
    </div>
  );
};

export default Contact;
